var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{class:'mt-' + _vm.spaceBetween + ' mb-' + _vm.spaceBetween,attrs:{"span":24}},[_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }